module.exports = __webpack_public_path__ + "img/greatest-hits.db481419.png";